import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { LoadingOutlined } from "@ant-design/icons"

//------------------------------------------------------------------------------

function AppButton(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { children, onClick, htmlType, uxType, loading } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function getThemeClassName() {
    switch (uxType) {
      case "warning": {
        return "warning"
      }
      case "success": {
        return "success"
      }

      case "ghosted": {
        return "ghosted"
      }

      case "link": {
        return "link"
      }
      default: {
        return ""
      }
    }
  }
  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <button
      className={`${props.className} ${getThemeClassName()}`}
      type={htmlType}
      onClick={onClick}
    >
      {loading && <LoadingOutlined />}
      {children}
    </button>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppButton.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  uxType: PropTypes.string,
  htmlType: PropTypes.string,
  loading: PropTypes.bool,
}

AppButton.defaultProps = {
  onClick: () => {},
  htmlType: "submit",
  style: "default",
}

// ----------------------------------------------------------------------------

const StyledAppButton = styled(AppButton)`
  & {
    position: relative;

    padding: 0 24px;
    max-width: 300px;
    height: 36px;
    overflow: hidden;
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.primaryColor};

    font-weight: 600;
    color: ${(props) => props.theme.colors.textOnPrimary} !important;

    cursor: pointer;
    outline: none;
    transition: all 0.2s ease-in-out;

    :hover {
      ::before {
        content: "";

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background-color: ${(props) =>
          `${props.theme.colors.hoverActiveClearer}`};
      }
    }
  }

  &.ghosted {
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    background-color: transparent;
    color: ${(props) => props.theme.colors.primaryColor} !important;

    :hover {
    }
  }

  &.success {
    border: 1px solid ${(props) => props.theme.colors.successColor};
    background-color: transparent;
    color: ${(props) => props.theme.colors.successColor} !important;

    :hover {
    }
  }

  &.link {
    padding: 0 12px;
    border: none;
    background-color: transparent;
    color: ${(props) => props.theme.colors.primaryColor} !important;
    font-weight: 500;

    :hover {
    }
  }

  &.warning {
    border: 1px solid ${(props) => props.theme.colors.warningDarkColor};
    border-radius: 4px;
    background-color: transparent;
    color: ${(props) => props.theme.colors.warningDarkColor} !important;

    :hover {
      border-color: ${(props) => props.theme.colors.warningLightColor};
      color: ${(props) => props.theme.colors.warningLightColor} !important;
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledAppButton
